import { combine, withState, withCallback } from 'react-hooks-combine'

import PasswordComponent from './component'

export default combine(
  withState('type', 'setType', 'password'),
  withCallback(
    'onTriggerType',
    ({ setType }) =>
      () => {
        setType((type) => (type === 'text' ? 'password' : 'text'))
      },
    []
  )
)(PasswordComponent)
